import React, { ComponentClass, FunctionComponent } from 'react';
import ReactDOM from 'react-dom';
import { first } from './domUtils';

export function render(element: JSX.Element, selector: string) {
    const root = first(selector);
    if (root == null) {
        return;
    }

    ReactDOM.render(element, root);
}
